import React, { Component } from "react";
import styled from "styled-components";
import { graphql, compose } from "react-apollo";
import { mutationSetupAccount, mutationRegistration } from "Apollo";
import { ShowNotice } from "Store";
import NotificationBox from "module-common/NotificationBox";
import backgroundSetup from "../img/nolimit/background-setup.png";
import logoCare from "../img/nolimit/logo-shadow.png";

export default compose(
  graphql(mutationSetupAccount, {
    name: "mutateSetupAccount"
  }),
  graphql(mutationRegistration, {
    name: "mutateRegister"
  })
)(
  class FirstTime extends Component {
    state = {
      email: "",
      company: "",
      username: "",
      password: "",
      repassword: "",
      referralCode: ""
    };

    getInitialData = async () => {
      const { mutateSetupAccount } = this.props;
      const token = new URL(window.location.href).searchParams.get("token");
      try {
        const result = await mutateSetupAccount({
          variables: {
            code: token
          }
        });
        return result.data.registrationEmailValidation;
      } catch (error) {
        return false;
      }
    };

    componentDidMount() {
      this.getInitialData();
      this.getInitialData().then(value => {
        this.setState({
          email: value.email,
          company: value.companyName,
          username: value.username
        });
      });
    }

    render() {
      const {
        email,
        company,
        username,
        password,
        repassword,
        referralCode
      } = this.state;
      return (
        <Screen>
          <LogoCare alt="logo care" src={logoCare} />
          <Panel onSubmit={event => event.preventDefault()}>
            <NotificationBox />
            <Strong>Setup Your Account</Strong>
            <Count>Step 1/2</Count>
            <Label>Company*</Label>
            <Input
              label="Company"
              name="company"
              value={company}
              onChange={e => this.setState({ company: e.target.value })}
            />

            <Label>Username*</Label>
            <Input
              label="Username"
              name="username"
              value={username}
              onChange={e => this.setState({ username: e.target.value })}
            />

            <Label>Password*</Label>
            <Input
              label="Passowrd"
              name="password"
              value={password}
              type="password"
              onChange={e => this.setState({ password: e.target.value })}
            />
            <Label>Re-Type Password*</Label>
            <Input
              label="Re-Passowrd"
              name="repassword"
              value={repassword}
              type="password"
              onChange={e => this.setState({ repassword: e.target.value })}
            />
            <Label>Referral Code</Label>
            <Input
              label="Referral Code"
              name="referralCode"
              value={referralCode}
              onChange={e =>
                this.setState({
                  referralCode: e.target.value
                })
              }
            />
            <Row />

            <SecButton>
              <Register type="Submit" onClick={this.onSubmit}>
                Next Step
              </Register>
            </SecButton>
          </Panel>
        </Screen>
      );
    }

    onSubmit = async () => {
      const {
        email,
        company,
        username,
        password,
        repassword,
        referralCode
      } = this.state;
      const { mutateRegister } = this.props;

      try {
        if (company && username && password && repassword) {
          if (password !== repassword) {
            ShowNotice("register-password-error");
          } else {
            await mutateRegister({
              variables: {
                email: email,
                company: company,
                username: username,
                password: password,
                rePassword: repassword,
                refCode: referralCode
              }
            });
            window.location = "/connect-account";
            ShowNotice("setup-account-success");
          }
        } else {
          ShowNotice("register-form-error");
        }
      } catch (error) {
        ShowNotice("setup-account-error");
      }
    };
  }
);

const Screen = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: url(${backgroundSetup});
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: bottom;
`;

const LogoCare = styled.img`
  display: flex;
  width: 275px;
  height: auto;
  justify-content: center;
  margin-bottom: 10px;
`;

const Strong = styled.span`
  font-size: 22px;
  text-align: center;
  margin-bottom: 15px;
  color: #3bbeb6;
`;

const Count = styled.div`
  position: fixed;
  top: 30px;
  right: 30px;
  font-size: 16px;
  color: #898989;
`;
const Panel = styled.form`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: none;
  width: 500px;
  padding: 30px 50px;
  margin-left: 0px;
  background: white;
  border-radius: 10px;
  box-shadow: 0px 0px 30px 5px rgba(0, 0, 0, 0.1);
`;
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: -6px;
  margin-bottom: 40px;
`;

const Label = styled.label`
  color: #898989;
  font-weight: bold;
  font-weight: 400;
  margin-bottom: 3px;
`;

const Input = styled.input`
  background-color: transparent;
  padding: 5px;
  border: solid 1px #e7e9f6;
  border-radius: 5px;
  margin-bottom: 10px;
  color: #898989;
  font-size: 1rem;
  transition: border 0.3s;
  &:focus {
    outline: none;
    border: solid 1px #6bbcf4;
  }
`;

const Register = styled.button`
  flex: 1;
  display: inline-flex;
  vertical-align: top;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  color: white;
  transition: 0.3s;
  font-size: 14px;
  cursor: pointer;
  border-radius: 30px;
  white-space: nowrap;
  user-select: none;
  background: blue;
  padding: 10px;
  background: #01adef;
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 2px 0px;
`;

const SecButton = styled.section`
  display: flex;
  flex: 1;
  margin-top: -20px;
  width: 150px;
  margin-left: auto;
  margin-right: auto;
`;



// WEBPACK FOOTER //
// ./src/module-first-time/ModuleFirstTimeWithQueryMutation.js